<template>
    <div>
        <div class="bottom-text">
            <div class="logo-bottom"></div>
            <div class="bottom-text-center">
                <span style="font-size: 20px">联系我们</span>
                <router-link to="business" class="go-page" :underline="false">商务合作</router-link>
                <span> &nbsp; </span>
            </div>
            <div class="bottom-text-center">
                <span style="font-size: 20px">法律义务</span>
                <span>用户协议</span>
                <router-link :to="{ path: '/Privacy' }" target="_blank">隐私协议</router-link>
                <!-- <el-button
          type="text"
          @click="toPrivacy"
        >隐私协议</el-button> -->
                <!-- javascript:window.open('http://www.fenglinghudong.com/#/Privacy') -->
            </div>
            <div class="bottom-text-center">
                <span style="font-size: 20px">关注我们</span>
                <div class="pulic-cls">
                    <div v-for="(item, index) in publicData" :key="index" class="public-item">
                        <el-tooltip placement="top" effect="light">
                            <div class="pulic--logo-cls" :style="{ 'background-image': 'url(' + item.image + ')' }"></div>
                            <div slot="content">
                                <el-image style="width: 100px; height: 100px" src="https://game-cdn.feigo.fun/uploads/20201202/ovj29VTdGsfmUfHbsEbWjhwpcaPhNm3P.png" fit="cover"></el-image>
                            </div>
                        </el-tooltip>
                        <div style="font-size: 14px">{{ item.name }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="banquan">
            <span><a href="https://beian.miit.gov.cn/" style="color: #ffff">闽ICP备17013745号</a> COPYRIGHT ©2017 – 2020 风领科技. ALL RIGHTS RESERVED</span>
            <span>厦门风领科技有限公司 版权所有</span>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            publicData: [
                {
                    image: 'https://game-cdn.feigo.fun/uploads/20201202/kr1XgRFggXr4FDV9sMvv8EyTKo6bS11i.png',
                    name: '微信公众号'
                }
            ]
        };
    },
    methods: {
        business() {
            this.$router.push('./business');
        },
        toPrivacy() {
            const privacy = this.$router.resolve({ path: './Privacy' });
            window.open(privacy.href, '_blank');
        }
    }
};
</script>
<style  src='../css/bottom.css' >
</style>